export default {

    props:
    {
        value: null,
        disabled: Boolean,
        readonly: Boolean,
        required: Boolean,
    },

    watch:
    {
        value(val)
        {
            this.internalValue = val
        },

        internalValue(val)
        {
            this.$emit('input', val)
            this.$emit('change')
        },

    },

    data()
    {
        return {
            internalValue: this.value,
        }
    },

}



// WEBPACK FOOTER //
// ./src/components/forms/elements/baseInput.js